import {
  Root,
  Home,
  News,
  Events,
  Promotion,
  PromotionDetail,
  NewsDetail,
  EventDetail,
  Career,
  About,
  Ourshow,
  Contact,
  HighlightDetail,
  Booking,
  Agent,
  AgentLoginFirstTime,
  Pdpa,
} from "./pages";

export default [
  {
    component: Root,
    routes: [
      {
        path: "/",
        exact: true,
        component: Home,
      },
      {
        path: "/news",
        exact: true,
        component: News,
      },
      {
        path: "/event",
        exact: true,
        component: Events,
      },
      {
        path: "/promotion",
        exact: true,
        component: Promotion,
      },
      {
        path: "/promotion/detail/:id",
        exact: false,
        component: PromotionDetail,
      },
      {
        path: "/news/detail/:id",
        exact: false,
        component: NewsDetail,
      },
      {
        path: "/event/detail/:id",
        exact: false,
        component: EventDetail,
      },
      {
        path: "/highlight-detail/:id",
        exact: true,
        component: HighlightDetail,
      },
      {
        path: "/career",
        exact: true,
        component: Career,
      },
      {
        path: "/about",
        exact: true,
        component: About,
      },
      {
        path: "/show",
        exact: true,
        component: Ourshow,
      },
      {
        path: "/contact",
        exact: true,
        component: Contact,
      },
      {
        path: "/booking",
        exact: true,
        component: Booking,
      },
      {
        path: "/agent",
        exact: true,
        component: Agent,
      },
      {
        path: "/agent-login-first-time",
        exact: true,
        component: AgentLoginFirstTime,
      },
      {
        path: "/pdpa/:type",
        exact: true,
        component: Pdpa,
      },
      {
        component: Home,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/routes.js